import { useContext, createContext, useState, ReactNode } from "react";

type TPagination = {
  pageNumber: number;
  checked: boolean;
};

interface INavigationContextProps {
  updatedCurrentPage: (pageParam: number) => void;
  updateCheckBoxPage: (pageParam: number, check: boolean) => void;
  pageList: TPagination[];
  seeMoreText: string;
  setSeeMoreText: (text: string) => void;
  seeMoreModalWidth: string;
  setSeeMoreModalWidth: (width: string) => void;
  seeMoreTitle: string;
  setSeeMoreTitle: (text: string) => void;
  selectedAccountCombo: number | null;
  setSelectedAccountCombo: (account: number | null) => void;
  rowsPerPage: number;
  setRowsPerPage: (rows: number) => void;
  order: "asc" | "desc";
  setOrder: (order: "asc" | "desc") => void;
  defaultCriterioId: number;
  setDefaultCriterioId: (id: number) => void;
}

const NavContext = createContext({} as INavigationContextProps);

export const NavContextProvider = ({ children }: { children: ReactNode }) => {
  const [pageList, setPageList] = useState<TPagination[]>([
    { pageNumber: 1, checked: false }
  ]);
  const [seeMoreText, setSeeMoreText] = useState<string>("ver mais...");
  const [seeMoreModalWidth, setSeeMoreModalWidth] = useState<string>("450px");
  const [seeMoreTitle, setSeeMoreTitle] = useState<string>("Regra");
  const [selectedAccountCombo, setSelectedAccountCombo] = useState<
    number | null
  >(null);
  const [rowsPerPage, setRowsPerPage] = useState<number>(10);
  const [order, setOrder] = useState<"asc" | "desc">("desc");
  const [defaultCriterioId, setDefaultCriterioId] = useState<number>(0);

  const updatedCurrentPage = (pageParam: number) => {
    const pageAux = pageList.map((p) => p.pageNumber);
    const newPage: TPagination = { pageNumber: pageParam, checked: false };
    if (!pageAux.includes(pageParam)) {
      setPageList((prev) => [...prev, newPage]);
    }
  };

  const updateCheckBoxPage = (pageParam: number, check: boolean) => {
    setPageList((prevPageList) =>
      prevPageList.map((p) =>
        p.pageNumber === pageParam ? { ...p, checked: check } : p
      )
    );
  };

  return (
    <NavContext.Provider
      value={{
        pageList,
        updatedCurrentPage,
        updateCheckBoxPage,
        seeMoreText,
        setSeeMoreText,
        seeMoreModalWidth,
        setSeeMoreModalWidth,
        seeMoreTitle,
        setSeeMoreTitle,
        selectedAccountCombo,
        setSelectedAccountCombo,
        rowsPerPage,
        setRowsPerPage,
        order,
        setOrder,
        defaultCriterioId,
        setDefaultCriterioId
      }}
    >
      {children}
    </NavContext.Provider>
  );
};

export const useNavigationContext = () =>
  useContext<INavigationContextProps>(NavContext);
